import { FileTypes } from 'api/services/file/types';
import { IMenuItemType } from 'api/services/menuItems/types';
import { FormOperator, FormType, IForm, IFormView } from 'shared/Form/types';

export const fields: IForm = {
  label: {
    type: FormType.TEXT,
    label: 'Текст',
    extraKey: 'label',
    required: true,
    value: '',
  },
  link: {
    type: FormType.TEXT,
    label: 'Ссылка',
    extraKey: 'link',
    required: true,
    value: '',
    hiddenRef: [
      [
        {
          operator: FormOperator.NOT_EQUAL,
          ref: 'type',
          value: IMenuItemType.DEFAULT,
        },
      ],
    ],
  },
  type: {
    type: FormType.SELECT,
    label: 'Тип ссылки',
    extraKey: 'type',
    required: true,
    value: IMenuItemType.DEFAULT,
    options: [
      { value: IMenuItemType.DEFAULT, label: 'Внешняя ссылка' },
      { value: IMenuItemType.PAGE, label: 'Ссылка на страницу' },
      { value: IMenuItemType.POST, label: 'Ссылка на пост' },
      { value: IMenuItemType.TAXONOMY, label: 'Ссылка на таксономию' },
      { value: IMenuItemType.POST_CATEGORY, label: 'Ссылка на категорию' },
    ],
  },
  post: {
    type: FormType.SELECT,
    label: 'Пост',
    extraKey: 'postId',
    required: true,
    value: '',
    hiddenRef: [
      [
        {
          ref: 'type',
          operator: FormOperator.NOT_EQUAL,
          value: IMenuItemType.POST,
        },
      ],
    ],
    searchable: {
      labelKey: 'title',
      valueKey: 'id',
      url: '/posts',
      query: {
        skip: 0,
        take: 20,
      },
      withPaginate: true,
    },
  },
  page: {
    type: FormType.SELECT,
    label: 'Страница',
    extraKey: 'pageId',
    required: true,
    value: '',
    hiddenRef: [
      [
        {
          ref: 'type',
          operator: FormOperator.NOT_EQUAL,
          value: IMenuItemType.PAGE,
        },
      ],
    ],
    searchable: {
      labelKey: 'title',
      valueKey: 'id',
      url: '/pages',
    },
  },
  taxonomy: {
    type: FormType.SELECT,
    label: 'Таксономия',
    extraKey: 'taxonomyId',
    required: true,
    value: '',
    hiddenRef: [
      [
        {
          ref: 'type',
          operator: FormOperator.NOT_EQUAL,
          value: IMenuItemType.TAXONOMY,
        },
      ],
    ],
    searchable: {
      labelKey: 'title',
      valueKey: 'id',
      url: '/taxonomies',
    },
  },
  postCategory: {
    type: FormType.SELECT,
    label: 'Категория поста',
    extraKey: 'postCategoryId',
    required: true,
    value: '',
    hiddenRef: [
      [
        {
          ref: 'type',
          operator: FormOperator.NOT_EQUAL,
          value: IMenuItemType.POST_CATEGORY,
        },
      ],
    ],
    searchable: {
      labelKey: 'title',
      valueKey: 'id',
      url: '/post-categories',
    },
  },
  newWindow: {
    type: FormType.SWITCH,
    label: 'Открывать ссылку в новом окне?',
    extraKey: 'newWindow',
    value: false,
  },
  image: {
    type: FormType.FILE,
    label: 'Изображение',
    extraKey: 'image',
    fileType: FileTypes.IMAGE,
    width: 315,
    height: 175,
    value: '',
  },
};

export const view: IFormView = [
  {
    block: [
      ['label'],
      ['type'],
      ['post'],
      ['page'],
      ['taxonomy'],
      ['postCategory'],
      ['link'],
      ['newWindow'],
      ['image'],
    ],
  },
];
